import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=cbe58346&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"
import style0 from "./Balance.vue?vue&type=style&index=0&id=cbe58346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe58346",
  null
  
)

export default component.exports